import React from 'react'
import { Typography, Button, IconButton } from '@material-ui/core'
import { Delete as DeleteIcon } from '@material-ui/icons'
import ModuleStatusSelect from './ModuleStatusSelect'
import ContextButton from '../../shared/ContextButton'
import ContextIndicator from '../../shared/ContextIndicator'

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const ModuleCard = ({ module, onStatusChange, onSkipToggle, onDelete, onOpenContextDrawer, contextInfo }) => {
  const isSkipped = module.skipped
  const ownerName = module.owner?.name || 'Unassigned'

  return (
    <div style={{
      ...cardStyle,
      opacity: isSkipped ? 0.5 : 1,
      borderLeft: isSkipped ? '3px solid #ff9800' : '3px solid transparent'
    }}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: 14 }}>
            {module.scope}
          </Typography>
          {contextInfo && (
            <ContextIndicator
              hasBlocker={contextInfo.hasBlocker}
              noteCount={contextInfo.noteCount}
              hasReview={contextInfo.hasReview}
            />
          )}
        </div>
        <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
          Owner: {ownerName}
        </Typography>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {isSkipped ? (
          <Button
            size="small"
            onClick={() => onSkipToggle(module._id, false)}
            style={{ textTransform: 'none', fontSize: 11 }}
          >
            Restore
          </Button>
        ) : (
          <>
            <ModuleStatusSelect
              moduleId={module._id}
              status={module.status}
              onChange={onStatusChange}
            />
            <Button
              size="small"
              onClick={() => onSkipToggle(module._id, true)}
              style={{ textTransform: 'none', fontSize: 11, color: '#999' }}
            >
              Skip
            </Button>
          </>
        )}
        <ContextButton
          parentType="module"
          parentId={module._id}
          parentLabel={module.scope}
          onOpenDrawer={onOpenContextDrawer}
        />
        <IconButton size="small" onClick={() => onDelete(module._id)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  )
}

export default ModuleCard
